import { FC, useEffect, useState } from 'react';
import styles from './loanUsesHeroRange.module.scss';

type Props = {
  isVisible: boolean;
  id?: string;
};

export const LoanUsesHeroRange: FC<Props> = ({
  isVisible,
  id = 'interest-rate',
}) => {
  const [value, setValue] = useState(30);
  useEffect(() => {
    const startValue = value;
    const targetValue = isVisible ? 70 : 30;
    const duration = 1000;
    const startTime = performance.now();

    const animate = (currentTime: number) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const interpolatedValue =
        startValue + (targetValue - startValue) * progress;

      setValue(interpolatedValue);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setValue(targetValue);
      }
    };
    requestAnimationFrame(animate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  return (
    <label htmlFor={id} aria-label="Interest rate">
      <input
        id={id}
        className={`${styles.range} ${isVisible ? styles.isVisible : ''}`}
        type="range"
        min={0}
        max={100}
        value={value}
        onChange={(event) => event.preventDefault()}
        style={{
          background: `linear-gradient(to right, #18C2DE ${value}%, #ffffff33 ${value}%)`,
          transition: 'background 1s ease',
        }}
      />
    </label>
  );
};
